import React, { useEffect, useState } from "react";
import leaveAPI from "../api/leaveAPI";
import UserDashboard from "./UserDashboard";

const LeaveReport = () => {
  const [leaves, setLeaves] = useState([]);

  const fetchLeaves = async () => {
    try {
      const res = await leaveAPI.get("/all");
      setLeaves(res.data);
    } catch (err) {
      console.error("Error fetching leave data:", err);
    }
  };

  useEffect(() => {
    fetchLeaves();
  }, []);

  const updateStatus = async (id, status) => {
    try {
      await leaveAPI.patch(`/${id}/status`, { status });
      fetchLeaves();
    } catch (err) {
      console.error("Error updating status:", err);
    }
  };

  // 🔹 Helper to format From / To column
  const formatFromTo = (leave, type) => {
    if (leave.leaveType === "Permission") {
      const time = type === "from" ? leave.fromTime : leave.toTime;
      return time
        ? new Date(`1970-01-01T${time}`).toLocaleTimeString("en-GB", {
            hour: "2-digit",
            minute: "2-digit",
          })
        : "-";
    } else {
      const date = type === "from" ? leave.fromDate : leave.toDate;
      return date ? new Date(date).toLocaleDateString("en-GB") : "-";
    }
  };

  // 🔹 Helper to calculate duration
  const calculateDuration = (leave) => {
    if (leave.leaveType === "Permission" && leave.fromTime && leave.toTime) {
      const start = new Date(`1970-01-01T${leave.fromTime}`);
      const end = new Date(`1970-01-01T${leave.toTime}`);
      const hours = (end - start) / (1000 * 60 * 60);
      return `${hours.toFixed(1)} hr${hours > 1 ? "s" : ""}`;
    } else if (leave.fromDate && leave.toDate) {
      const start = new Date(leave.fromDate);
      const end = new Date(leave.toDate);
      const days = Math.ceil((end - start) / (1000 * 60 * 60 * 24)) + 1;
      return `${days} day${days > 1 ? "s" : ""}`;
    }
    return "-";
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-100 to-pink-100 pt-16">
      <UserDashboard />
      <div className="max-w-7xl mx-auto p-8">
        <div className="bg-white p-4 rounded-2xl shadow-xl">
          <h2 className="text-3xl font-mono font-bold text-purple-700 mb-3 text-center">
            Leave Report
          </h2>

          <div className="overflow-x-auto overflow-y-auto max-h-[calc(100vh-250px)] border rounded-lg">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-purple-100 text-purple-700 text-sm font-semibold uppercase sticky top-0 z-10">
                <tr>
                  <th className="py-3 px-4 text-left">Applied Date</th>
                  <th className="py-3 px-4 text-left">Profile</th>
                  <th className="py-3 px-4 text-left">Name</th>
                  <th className="py-3 px-4 text-left">Role</th>
                  <th className="py-3 px-4 text-left">Work Mode</th>
                  <th className="py-3 px-4 text-left">Leave Type</th>
                  <th className="py-3 px-4 text-left">From</th>
                  <th className="py-3 px-4 text-left">To</th>
                  <th className="py-3 px-4 text-left">Duration</th>
                  <th className="py-3 px-4 text-left">Reason</th>
                  <th className="py-3 px-4 text-left">Status</th>
                </tr>
              </thead>

              <tbody className="text-gray-800 text-sm">
                {leaves.map((leave, index) => (
                  <tr key={index} className="border-t hover:bg-yellow-50 transition">
                    <td className="py-2 px-4">
                      {new Date(leave.createdAt).toLocaleDateString("en-GB")}
                    </td>
                    <td className="py-2 px-4">
                      <img
                        src={leave.profileImage?.replace(/\\/g, "/")}
                        alt="profile"
                        className="w-10 h-10 rounded-full border mx-auto"
                      />
                    </td>
                    <td className="py-2 px-4">{leave.workerName}</td>
                    <td className="py-2 px-4">{leave.role}</td>
                    <td className="py-2 px-4">{leave.workMode}</td>
                    <td className="py-2 px-4">{leave.leaveType}</td>
                    <td className="py-2 px-4">{formatFromTo(leave, "from")}</td>
                    <td className="py-2 px-4">{formatFromTo(leave, "to")}</td>
                    <td className="py-2 px-4">{calculateDuration(leave)}</td>
                    <td className="py-2 px-4">{leave.reason}</td>
                    <td className="py-2 px-4">
                      {leave.status === "Pending" ? (
                        <div className="flex gap-2">
                          <button
                            onClick={() => updateStatus(leave._id, "Approved")}
                            className="px-3 py-2 bg-green-500 hover:bg-green-600 text-white text-xs rounded-lg"
                          >
                            Approve
                          </button>
                          <button
                            onClick={() => updateStatus(leave._id, "Rejected")}
                            className="px-3 py-2 bg-red-500 hover:bg-red-600 text-white text-xs rounded-lg"
                          >
                            Reject
                          </button>
                        </div>
                      ) : (
                        <span
                          className={`text-xs font-semibold px-3 py-2 rounded-full ${
                            leave.status === "Approved"
                              ? "bg-green-100 text-green-700"
                              : "bg-red-100 text-red-600"
                          }`}
                        >
                          {leave.status}
                        </span>
                      )}
                    </td>
                  </tr>
                ))}

                {leaves.length === 0 && (
                  <tr>
                    <td colSpan="11" className="text-center py-6 text-gray-500">
                      No leave records found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeaveReport;
